import { ref } from 'vue';

import { defineStore } from 'pinia';

export const useBillingGateDialogStore = defineStore('billingGateDialog', () => {
  const isOpen = ref(false);

  const open = () => {
    isOpen.value = true;
  };

  const close = () => {
    isOpen.value = false;
  };

  return {
    isOpen,
    open,
    close,
  };
});
